import styled, { keyframes } from 'styled-components'
import { v1 as color } from 'sidecar-design-library'
import Icon from '../IconV1'

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const LoadingSpinner = styled(Icon).attrs({
  name: 'processing',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.SILVER};
  animation: ${rotate360} 1s linear infinite;
  padding: 1.25rem;
  font-size: 3.75rem;
  width: 6.25rem;
  margin: auto;
`

export default LoadingSpinner
